'use client';

import { Button, LoadingIndicator } from '@commenda/kakashi';
import type React from 'react';

interface LinkedFormSheetLayoutProps {
  children: React.ReactNode;
  title?: string;
  hideHeader?: boolean;
  hideActions?: boolean;
  isSubmitting: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
}

/** Title, form cards and inline actions, laid out like the other form bottom sheets (e.g. AddPersonBottomsheet). */
export function LinkedFormSheetLayout({
  children,
  title,
  hideHeader = false,
  hideActions = false,
  isSubmitting,
  onCancel,
  onSubmit,
}: LinkedFormSheetLayoutProps) {
  return (
    <div className="w-full flex flex-col gap-8">
      {title && !hideHeader ? (
        <h2 className="w-full txt-large-bold text-2xl leading-8 text-text-primary">
          {title}
        </h2>
      ) : null}
      {children}
      {hideActions ? null : (
        <div className="w-full flex items-center justify-end gap-4 py-4">
          {onCancel ? (
            <Button
              variant="secondary"
              size="md"
              type="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            variant="primary"
            size="md"
            type="button"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? <LoadingIndicator size={16} /> : null}
            <span>Submit</span>
          </Button>
        </div>
      )}
    </div>
  );
}
